import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Appcost(props) {
  return (
    <div className="p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Cloud-Sustainable">
              <h2>
                Boost Your Business with Our End-to-End Serverless Computing
                services
              </h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Our team specializes in providing high-quality serverless
              computing services, providing customized solutions, and
              experienced support every step of the way. From strategic
              consulting to flawless implementation, we ensure your serverless
              move goes smoothly and efficiently. Experience the agility and
              scalability of serverless technology.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let's Connect!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Appcost;
